import { Pipe, PipeTransform } from '@angular/core';
import { CastValuePipe } from './cast-value.pipe';

@Pipe({ name: 'getBooleanResult' })
export class GetBooleanResultPipe implements PipeTransform {

  /** En caso de modificar el pipe también se debe modifica la función en el back Model/common/ajx_build_reports -> getBooleanResult */

  /* transform(): Pipe que devuelve el resultado booleano de la comparación entre 2 valores
    leftValue: Valor a comparar izquierdo
    rightValue: Valor a comparar derecho
    operator: operador de comparación
    cast: convertir los valores a un tipo específico
  */
  transform(leftValue: any, rightValue: any, operator: string, cast?: string): any {
    // operators: Tipos de operaciones que se pueden realizar
    const operators: { [undetermindeIndex: string]: (a: any, b: any) => boolean } = {
      includeAll: (a: any[], b: any[]) => b.map((elm: any) => a.includes(elm)).every((elm: boolean) => elm), // a incluye todos los valores de b
      includeAny: (a: any[], b: any[]) => b.map((elm: any) => a.includes(elm)).includes(true), // a incluye un valor de b
      bUndefined: (a: any, b: any) => [null, undefined, '', false].includes(b), // b Está indefinido
      aDefinite: (a: any, b: any) => ![null, undefined, '', false].includes(a), // a Está definido
      bDefinite: (a: any, b: any) => ![null, undefined, '', false].includes(b), // b Está definido
      every: (a: any, b: any) => a.every((elm: any) => elm === b), // Todo el array contiene
      '!!': (a: any, b: any) => [null, undefined, ''].includes(a), // a Está indefinido
      '===': (a: any, b: any) => a.includes(b), // Incluye
      '==': (a: any, b: any) => b.includes(a), // Incluye
      '>=': (a: any, b: any) => a >= b, // Mayor o igual a
      '<=': (a: any, b: any) => a <= b, // Menor o igual a
      '!': (a: any, b: any) => a !== b, // Diferente de
      '=': (a: any, b: any) => a === b, // Igual a
      '&': (a: any, b: any) => a && b,  // Todos cumplen condición
      '|': (a: any, b: any) => a || b,  // Alguno cumple condición
      '<': (a: any, b: any) => a < b,   // Menor que
      '>': (a: any, b: any) => a > b,   // Mayor que
    };
    // ↓ Verifica si se hara conversión de tipo a las variables
    if (cast) {
      leftValue = new CastValuePipe().transform(leftValue, cast as any);
      rightValue = new CastValuePipe().transform(rightValue, cast as any);
    }
    // Devuelve el resultado de la operación
    return operators[operator](leftValue, rightValue);
  }

}
